import { connect } from 'react-redux';
import { compose, lifecycle, renderNothing } from 'recompose';

import pubnub, { subscribe, unsubscribe } from '../common/pubnub';
import {
  getActiveShopId,
  getCurrentUserId,
} from '../auth/selectors';

const enhance = compose(
  connect(
    state => ({
      shopId: getActiveShopId(state),
      userId: getCurrentUserId(state),
    }),
  ),
  lifecycle({
    componentDidMount() {
      const channel = `handoff_${this.props.shopId}_${this.props.userId}`;
      subscribe({
        channel,
        message: ({ message }) => {
          const shouldHandle = message.publisher !== pubnub.getUUID();
          if (shouldHandle) {
            this.props.dispatch(message);
          }
        },
      });

      pubnub.setState({
        channels: [channel],
        state: {
          role: 'master',
          type: 'handoff',
        },
      });
    },
    componentWillUnmount() {
      unsubscribe(`handoff_${this.props.shopId}_${this.props.userId}`);
    },
  })
);

export default enhance(renderNothing());
